import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { TableComponent } from "../../components/common/table/table.component";
import { CommonModule } from "@angular/common";
import { MapN2pComponent } from "../map-n2p/map-n2p.component";
import { NgxSpinnerModule, NgxSpinnerService } from "ngx-spinner";
import { TitleTextPipe } from "../../custom.pipe";
import { ToastrService } from "ngx-toastr";
import { FormBuilder } from "@angular/forms";
import { ApiService } from "../../api.service";
import { SelectSmpN2pComponent } from "../select-smp-n2p/select-smp-n2p.component";

@Component({
  selector: "app-n2p-upstream-equipment",
  standalone: true,
  imports: [
    TableComponent,
    CommonModule,
    MapN2pComponent,SelectSmpN2pComponent,
    NgxSpinnerModule, TitleTextPipe
  ],
  templateUrl: "./n2p-upstream-equipment.component.html",
  styleUrls: ["./n2p-upstream-equipment.component.scss"]
})

export class N2pUpstreamEquipmentComponent implements OnInit {
  @Input() inputData: any;
  isLoading: boolean = false;
  select_bjl: boolean = false;
  upstream_screen: boolean = true;
  select_smp_screen: boolean = false;
  tableData: any;
  showMessage: boolean = false;
  MessageToShow: any;
  selected_spl :string = '';
  selectedFJLSPL: string ='';
  user_message: string ='';
  @ViewChild(TableComponent)
  tableChildComponent!: TableComponent;
  selectedSPL :string = '';
  
  constructor(private toastr: ToastrService,
    private fb: FormBuilder,
    private apiService: ApiService,
    private spinner: NgxSpinnerService) { 

  }

  ngOnInit() {

  }
  receiveTableEventUpstream(data: any) {
    this.inputData['selected_upstream_equipment'] = data;
    this.isLoading = true;
    this.spinner.show();
    this.apiService.selectUpstreamStructureN2P(this.inputData).subscribe({
      next: (response) => {

            if (response.message === 'select bjl structure n2p') {
              this.select_bjl = false;
              this.upstream_screen = false;
              this.inputData = response;
              this.select_smp_screen = true;
              this.tableData = response;
            }
            
            else {              
              if ('file_name' in response) {
                this.select_bjl = false;
                this.upstream_screen = false;
                this.showMessage = true;
                this.MessageToShow = response;
              } else {
                this.toastr.error(response.message, 'Error Message');
                console.log('error');
              }
            }

            this.isLoading = false;
            this.spinner.hide();
            // window.alert(response.messgae);
      }
      ,
      error: (error) => {
            this.isLoading = false;
            this.spinner.hide();
            this.toastr.error(
              `The API returned Unsuccessfull response : ${error}`,
              'Error Message'
            );
            //window.alert(`The API returned Unsuccessfull response : ${error}`);
          },
    });
  }
  
  fjladdSPL() {
  this.inputData['spl_type'] = this.selectedFJLSPL;
  this.isLoading = true;
  this.spinner.show();
  this.apiService.newFJLSPL(this.inputData).subscribe({
    next: (response) => {
      if (response.message === 'select bjl n2p') {
        this.select_bjl = true;
        this.upstream_screen = false;
        this.inputData = response;
        this.tableData = response;
        if (this.inputData.user_message !== '') {
          this.user_message = this.inputData.user_message;
        }
        this.tableChildComponent.initializeFunction(this.inputData);
      }
      else if (response.message.includes('No FSD avaliable to connect') || response.message.includes('SPL Limit reached')){
        this.toastr.error(response.message,'Error Message');
      }

      this.isLoading = false;
      this.spinner.hide();
    },
      error: (error) => {
            this.isLoading = false;
            this.spinner.hide();
            this.toastr.error(
              `The API returned Unsuccessfull response : ${error}`,
              'Error Message'
            );
            //window.alert(`The API returned Unsuccessfull response : ${error}`);
      },
  });
}
onfjlSPLChange(event: Event) {
  const select = event.target as HTMLSelectElement;
  this.selectedFJLSPL = select.value;
  // Also store it in inputData for convenience
  this.inputData['spl_type'] = this.selectedFJLSPL;
}


}
